<template>
	<v-container fluid class="pb-0">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat class="pb-0 pt-0">
					<v-card-text class="pa-2">
						<v-row class="d-flex justify-space-between">
							<v-col class="pb-0 pt-0">
								<v-card-title class="justify-left align-center pa-2">
									{{ $t('titles.transactions') }}</v-card-title
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0">
								<v-simple-table fixed-header dense height="400px">
									<template v-slot:default>
										<thead>
											<tr>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.type') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.itemType') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.course') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.candidate') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.date') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.user') }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(item, key) in items"
												:key="key"
												:class="{ 'cursor-pointer': true }"
											>
												<td style="white-space: nowrap">
													{{ item.payment_contract_transaction_type.name }}
												</td>
												<td style="white-space: nowrap">
													{{ item.payment_contract_item_type.name }}
												</td>
												<td style="white-space: nowrap">
													{{
														item.item_type_id == 1
															? item.payment_contract_item.course.code +
															  ' ' +
															  item.payment_contract_item.course.name
															: ''
													}}
												</td>
												<td style="white-space: nowrap">
													{{ item.candidate.full_name }}
												</td>
												<td style="white-space: nowrap">
													{{ item.created_at }}
												</td>
												<td style="white-space: nowrap">
													{{ item.user != null ? item.user.full_name : '' }}
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'PaymentContractTransactions',
	data: function () {
		return {
			items: [],
		};
	},
	methods: {
		reloadData() {
			let vm = this;
			this.$APICall(
				'get',
				'payment-contract-transactions/' + this.$route.params.id,
				null,
				(data, success) => {
					if (success) {
						vm.items = data.items;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.reloadData();
	},
};
</script>

<style scoped></style>
